const protocol = process.env.VUE_APP_HTTP_SSL === 'true' ? 'https' : 'http'
const baseURL = `${protocol}://${process.env.VUE_APP_BASE_API}`

export {
  baseURL
}
